// extracted by mini-css-extract-plugin
export var button = "ButtonPrimary-module--button--85okd";
export var disabled = "ButtonPrimary-module--disabled--mleYn";
export var text = "ButtonPrimary-module--text--Xaym5";